import angular from 'angular';
import template from './template.html';
import './style.scss';

export class MatchScore {
    /* @ngInject */
    constructor($filter) {
        this.$filter = $filter;
    }

    $onChanges() {
        this.formattedMatchScore = this.getFormattedMatchScore(this.matchScore || 0.0);
    }

    getFormattedMatchScore(matchScore) {
        const stringifiedMatchScore = (+matchScore * 100).toFixed(0) || '0';

        return `${this.$filter('translate')('MATCH_SCORE')} ${stringifiedMatchScore}%`;
    }
}

export const MatchScoreConfiguration = {
    template,
    bindings: {
        matchScore: '<'
    },
    controller: MatchScore,
    controllerAs: 'matchScoreCtrl'
};

angular.module('TALENYA-FE').component('matchScore', MatchScoreConfiguration);
